import { Stack } from '@mui/material';
import { ApolloError } from '@apollo/client';

import { ReferralInfoFragment } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  EmptyDataTable,
  IPaginationProps,
  LinearProgress,
  Paper,
  SearchFormProps,
} from '@occc-app/design-system';

import {
  MembershipReferralInfo,
  MembershipReferralsTable,
  MembershipReferralsTableHeader,
} from './components';

type MembershipReferralsPageProps = {
  totalReferrals: number;
  referralCode: string;
  referrals: ReferralInfoFragment[];
  paginationProps: IPaginationProps;
  isReferralsLoading: boolean;
  isReferralInfoLoading: boolean;
  search: {
    value?: string;
    onSubmit: SearchFormProps['onSubmit'];
  };
  error?: ApolloError;
};

export const MembershipReferralsPage = (props: MembershipReferralsPageProps) => {
  const {
    totalReferrals,
    referralCode,
    referrals,
    paginationProps,
    isReferralsLoading,
    isReferralInfoLoading,
    search,
    error,
  } = props;

  return (
    <Stack spacing={1}>
      <MembershipReferralInfo
        totalReferrals={totalReferrals}
        referralCode={referralCode}
        isLoading={isReferralInfoLoading}
      />
      {/*TableHeader component has white background and no border radius */}
      {/*so we need to add overflow hidden to keep rounded borders*/}
      <Paper sx={{ overflow: 'hidden' }}>
        <MembershipReferralsTableHeader search={search} />
        <MembershipReferralsTable
          referrals={referrals}
          paginationProps={paginationProps}
          loading={isReferralsLoading}
          error={error}
        />
      </Paper>
    </Stack>
  );
};
